module.exports = __webpack_public_path__ + "static/media/step-background-2.08ccf354.png";